import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICES]: {
		url:'/company/:companyId/done_works/:doneWorkId/services/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/services/:serviceId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/services/:serviceId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].GET_DONE_WORKS_SERVICE]: {
		url: '/company/:companyId/done_works/:doneWorkId/services/:serviceId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].CREATE_DONE_WORKS_SERVICE]: {
		url:'/company/:companyId/done_works/:doneWorkId/services/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PATCH_DONE_WORKS_SERVICE]: {
		url: '/company/:companyId/done_works/:doneWorkId/services/:serviceId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].PUT_DONE_WORKS_SERVICE]: {
		url: '/company/:companyId/done_works/:doneWorkId/services/:serviceId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_SERVICES].DELETE_DONE_WORKS_SERVICE]: {
		url: '/company/:companyId/done_works/:doneWorkId/services/:serviceId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}